import Modal from '../Modal'

$(() => {
  $(".js-open-modal-by-url").click(function (e) {
    e.preventDefault();

    Modal.setType('full-page').then(() => {
      Modal.getComponent().setContent('Загружаем документ...')
    })

    const url = $(this).attr('href');
    $.get(url, {ajax: true}, function (data) {
      Modal.$children[0].setContent(data)
    })
  });
})
